import { createI18n } from 'vue-i18n';
import i18n_ko from '@/locales/ko.json';
import i18n_en from '@/locales/en.json';
import message_ko from '@/locales/message_ko.json'
import message_en from '@/locales/message_en.json'
import response_ko from '@/locales/response_ko.json'
import response_en from '@/locales/response_en.json'
import store from '@/store/store'
import { getLang } from '@/utils/commonUtils';


// 키값과 json파일 추가하기
const messages = {
  ko: {
    common : i18n_ko ,           //페이지별로 사용할 별도의 json파일을 구성하면 될듯 만들떈 반드시 ko en 파일 두개만들어야함   
    message : message_ko,
    response: response_ko
  },
  en: {
    common : i18n_en ,
    message : message_en,
    response: response_en
}
};

// 기본 언어 설정 (fallback)
// const defaultLang = process.env.VUE_APP_LANG;
const defaultLang = 'ko'

// 로컬 스토리지에서 언어 가져오기
const storedLang = getLang()
// localStorage.getItem('lang');
// 언어가 저장되어 있지 않다면 기본 언어로 설정
const lang = storedLang || defaultLang;

const i18n = createI18n({
  legacy: false, // Composition API 스타일 사용
  locale: lang,
  messages,
});


export default i18n;